import(/* webpackMode: "eager" */ "/app/web/src/app/global-error.tsx");
